module.exports = __webpack_public_path__ + "static/media/dessert.f9fcd014.png";